"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.PrevisuCadreComplet = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _profcadresprix = require("@bko/profcadresprix");

var _idxImage = require("./idxImage");

var _previsuPasse = require("./previsuPasse");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable no-case-declarations */


var PrevisuCadreComplet = function PrevisuCadreComplet(props) {
  var _styleDivDroite, _styleDivGauche, _styleDivBas;

  var imgDoublo = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1]; // devrait être à true


  var _useState2 = (0, _react.useState)(false),
      loading2 = _useState2[0],
      setLoading2 = _useState2[1];

  (0, _react.useEffect)(function () {
    var img = typeof document !== "undefined" ? document.querySelector("[data-image-check-loading] img") : null;

    if (img !== null) {
      setLoading(!(img.complete && img.naturalHeight !== 0));
    } else setLoading(false); // devrait être à true

  }, []);
  (0, _react.useEffect)(function () {
    if (props.pageProduit.doublo !== null) {
      setLoading2(false); // devrait être à true
    }
  }, [props.pageProduit.doublo !== null ? props.pageProduit.doublo.ba_id : props.pageProduit.doublo]);
  var largeurFixe = props.largeurFixe,
      hauteurFixe = props.hauteurFixe,
      product = props.product;
  var _props$pageProduit = props.pageProduit,
      cartonBarriere = _props$pageProduit.cartonBarriere,
      doublo = _props$pageProduit.doublo,
      isorel = _props$pageProduit.isorel,
      largeur = _props$pageProduit.largeur,
      hauteur = _props$pageProduit.hauteur,
      pp = _props$pageProduit.pp,
      service = _props$pageProduit.service;
  var largeurSujet = largeur;
  var hauteurSujet = hauteur;
  var baguetteHauteurCm = parseFloat(product.ba_largeur);
  var largeurPx = largeurFixe,
      hauteurPx = hauteurFixe;

  var _getSizeInfos = (0, _profcadresprix.getSizeInfos)({
    pp: pp,
    hauteur: hauteurSujet,
    largeur: largeurSujet,
    doublo: doublo
  }, product),
      fullWidthCm = _getSizeInfos.fullWidthCm,
      fullHeightCm = _getSizeInfos.fullHeightCm,
      largeurIntra = _getSizeInfos.largeurIntra,
      hauteurIntra = _getSizeInfos.hauteurIntra,
      recouvrement = _getSizeInfos.recouvrement,
      largeurBaguettes = _getSizeInfos.largeurBaguettes; // Ceci sera notre ratio :


  var cmToPx = Math.min(largeurPx / fullWidthCm, hauteurPx / fullHeightCm);
  var baguetteHauteurPx = baguetteHauteurCm * cmToPx;
  var cadreLargeurPx = fullWidthCm * cmToPx;
  var cadreHauteurPx = fullHeightCm * cmToPx;
  var bg = isorel ? cartonBarriere ? "#FBEAD4" : "#cdae83" : props.couleurInterieur;
  var styleCadre = {
    position: "relative",
    width: fullWidthCm * cmToPx,
    height: fullHeightCm * cmToPx,
    backgroundColor: typeof pp.forme !== 'undefined' && pp.forme === 'ovale' ? pp.pp.pa_passe_hexa : bg
  }; // DIV IMAGES :

  var styleDivHaut = {
    position: "absolute",
    width: fullWidthCm * cmToPx,
    height: baguetteHauteurPx,
    zIndex: 9,
    overflow: "hidden"
  };
  var styleDivDroite = (_styleDivDroite = {
    position: "absolute",
    width: baguetteHauteurPx,
    height: cadreHauteurPx,
    left: cadreLargeurPx - baguetteHauteurPx + 1,
    top: 0,
    overflow: "hidden",
    transform: "rotate(180deg)",
    zIndex: 9
  }, _styleDivDroite["overflow"] = "hidden", _styleDivDroite.clipPath = "polygon(" + baguetteHauteurPx + "px " + baguetteHauteurPx + "px, 0 0, 0 " + cadreHauteurPx + "px, " + baguetteHauteurPx + "px " + (cadreHauteurPx - baguetteHauteurPx) + "px)", _styleDivDroite);
  var styleDivGauche = (_styleDivGauche = {
    position: "absolute",
    width: baguetteHauteurPx,
    height: cadreHauteurPx,
    left: 0,
    top: 0,
    overflow: "hidden"
  }, _styleDivGauche["overflow"] = "hidden", _styleDivGauche.clipPath = "polygon(" + baguetteHauteurPx + "px " + baguetteHauteurPx + "px, 0 0, 0 " + cadreHauteurPx + "px, " + baguetteHauteurPx + "px " + (cadreHauteurPx - baguetteHauteurPx) + "px)", _styleDivGauche.zIndex = 9, _styleDivGauche);
  var styleDivBas = (_styleDivBas = {
    position: "absolute",
    overflow: "hidden",
    width: cadreLargeurPx,
    height: baguetteHauteurPx,
    top: cadreHauteurPx - baguetteHauteurPx + "px",
    transform: "rotate(180deg)"
  }, _styleDivBas["overflow"] = "hidden", _styleDivBas.zIndex = 9, _styleDivBas); // IMAGES :

  var styleImageHaut = {
    position: "absolute",
    // width: fullWidthCm * cmToPx,
    height: baguetteHauteurPx,
    boxShadow: "1px 1px 5px rgb(85, 85, 85, 0.5)"
  };
  var styleImageBas = {
    position: "absolute",
    // width: largeurPx,
    height: baguetteHauteurPx
  };
  var styleImageDroite = {
    position: "absolute",
    width: largeurPx,
    top: cadreHauteurPx,
    left: 0,
    transformOrigin: "top left",
    transform: "rotate(-90deg)",
    height: baguetteHauteurPx
  };
  var styleImageGauche = {
    position: "absolute",
    top: largeurPx,
    left: 0,
    width: largeurPx,
    transformOrigin: "top left",
    transform: "rotate(-90deg)",
    height: baguetteHauteurPx,
    boxShadow: "1px 1px 5px rgb(85, 85, 85, 0.5)"
  };
  var baguetteHauteurPx2;
  var styleDivDroite2;
  var styleDivHaut2;
  var styleDivGauche2;
  var styleDivBas2;
  var styleImageHaut2;
  var styleImageBas2;
  var styleImageDroite2;
  var styleImageGauche2;

  if (doublo !== null) {
    if (fullWidthCm > fullHeightCm) {
      baguetteHauteurPx2 = doublo.ba_largeur * largeurPx / fullWidthCm;
    } else {
      baguetteHauteurPx2 = doublo.ba_largeur * hauteurPx / fullHeightCm;
    }

    var cadreLargeurPx2 = cadreLargeurPx - 2 * (baguetteHauteurPx - recouvrement * cmToPx);
    var cadreHauteurPx2 = cadreHauteurPx - 2 * (baguetteHauteurPx - recouvrement * cmToPx); // Conteneur baguette haut

    styleDivHaut2 = {
      width: cadreLargeurPx2,
      height: baguetteHauteurPx2,
      top: baguetteHauteurPx - recouvrement * cmToPx,
      left: baguetteHauteurPx - recouvrement * cmToPx,
      position: "absolute",
      zIndex: 8
    }; // Conteneur baguette droite

    styleDivDroite2 = {
      position: "absolute",
      width: baguetteHauteurPx2,
      height: cadreHauteurPx2,
      top: baguetteHauteurPx - recouvrement * cmToPx,
      right: baguetteHauteurPx - recouvrement * cmToPx,
      clipPath: "polygon(" + baguetteHauteurPx2 + "px " + baguetteHauteurPx2 + "px, 0 0, 0 " + cadreHauteurPx2 + "px, " + baguetteHauteurPx2 + "px " + (cadreHauteurPx2 - baguetteHauteurPx2) + "px)",
      transform: "rotate(180deg)",
      zIndex: 8
    }; // Conteneur baguette gauche

    styleDivGauche2 = {
      position: "absolute",
      left: baguetteHauteurPx - recouvrement * cmToPx,
      top: baguetteHauteurPx - recouvrement * cmToPx,
      width: baguetteHauteurPx2,
      height: cadreHauteurPx2,
      clipPath: "polygon(" + baguetteHauteurPx2 + "px " + baguetteHauteurPx2 + "px, 0 0, 0 " + cadreHauteurPx2 + "px, " + baguetteHauteurPx2 + "px " + (cadreHauteurPx2 - baguetteHauteurPx2) + "px)",
      zIndex: 8
    }; // Conteneur baguette bas

    styleDivBas2 = {
      position: "absolute",
      left: baguetteHauteurPx - recouvrement * cmToPx,
      bottom: baguetteHauteurPx - recouvrement * cmToPx,
      width: cadreLargeurPx2,
      height: baguetteHauteurPx2,
      transform: "rotate(180deg)",
      zIndex: 8
    }; // Baguette haut

    styleImageHaut2 = {
      position: "absolute",
      width: cadreLargeurPx2,
      height: baguetteHauteurPx2
    }; // Baguette bas

    styleImageBas2 = {
      position: "absolute",
      width: cadreLargeurPx2,
      height: baguetteHauteurPx2
    }; // Baguette droite

    styleImageDroite2 = {
      position: "absolute",
      width: cadreHauteurPx2,
      height: baguetteHauteurPx2,
      transform: "rotate(-90deg)",
      transformOrigin: "center",
      top: cadreHauteurPx2 / 2 - baguetteHauteurPx2 / 2,
      left: 0 - cadreHauteurPx2 / 2 + baguetteHauteurPx2 / 2
    }; // Baguette gauche

    styleImageGauche2 = {
      position: "relative",
      width: cadreHauteurPx2,
      height: baguetteHauteurPx2,
      transform: "rotate(-90deg)",
      transformOrigin: "center",
      top: cadreHauteurPx2 / 2 - baguetteHauteurPx2 / 2,
      left: 0 - cadreHauteurPx2 / 2 + baguetteHauteurPx2 / 2
    };
  }

  var styleLoader = {
    display: 'none',
    background: "white",
    zIndex: 2,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    textAlign: "center",
    paddingTop: cadreHauteurPx / 2 - 25
  };
  var stylePhoto = {
    background: "url(" + props.photo + ")",
    width: largeurSujet * cmToPx,
    position: "absolute",
    backgroundSize: "cover",
    zIndex: 7,
    left: (largeurBaguettes + (pp.type !== null ? pp.margeG : 0)) * cmToPx,
    top: (largeurBaguettes + (pp.type !== null ? pp.margeH : 0)) * cmToPx,
    height: hauteurSujet * cmToPx
  }; // Spécificités prévisu :

  if (product.fa_id === 475) {
    // Entre 2 verres
    stylePhoto.width = (largeurSujet - 10) * cmToPx + 4;
    stylePhoto.height = (hauteurSujet - 10) * cmToPx + 4;
    stylePhoto.left = (largeurBaguettes + pp.margeG + 5) * cmToPx - 2;
    stylePhoto.top = (largeurBaguettes + pp.margeH + 5) * cmToPx - 2;
  }

  var styleDivPhotos = {
    position: "absolute",
    zIndex: 7,
    left: largeurBaguettes * cmToPx,
    top: largeurBaguettes * cmToPx,
    height: hauteurIntra * cmToPx,
    width: largeurIntra * cmToPx,
    textAlign: "left",
    lineHeight: 0
  };
  var stylePhotos = {
    backgroundSize: "cover",
    height: hauteurSujet * cmToPx,
    width: largeurSujet * cmToPx,
    display: "inline-block",
    marginTop: pp.margeH * cmToPx,
    marginLeft: pp.margeG * cmToPx
  };
  var largeurSujetS = {
    position: "absolute",
    left: (largeurBaguettes + pp.margeG) * cmToPx + largeur * cmToPx / 2 - 30,
    top: (largeurBaguettes + pp.margeH) * cmToPx,
    background: "white",
    zIndex: 20,
    borderRadius: 10,
    textAlign: "center",
    padding: "0 10px",
    fontSize: "13px",
    fontWeight: "bold"
  };
  var hauteurSujetS = {
    position: "absolute",
    left: (largeurBaguettes + pp.margeG) * cmToPx - 17,
    top: (largeurBaguettes + pp.margeH) * cmToPx + hauteur * cmToPx / 2 - 10,
    transform: "rotate(-90deg)",
    background: "white",
    zIndex: 20,
    borderRadius: 10,
    textAlign: "center",
    padding: "0 10px",
    fontSize: "13px",
    fontWeight: "bold"
  };
  var styleMargesAct = {
    background: "#ffdd57",
    fontWeight: "bold",
    border: "1px solid #8e7617",
    boxShadow: "0 0 3px #22629b",
    fontSize: "1rem"
  };
  var Image = props.imageComponent;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: styleCadre,
    className: "cadreComplet"
  }, loading || doublo !== null && loading2 ? /*#__PURE__*/_react.default.createElement("div", {
    style: styleLoader
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner"
  })) : "", /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivHaut,
    "data-image-check-loading": true
  }, /*#__PURE__*/_react.default.createElement(Image, {
    key: fullWidthCm + "-" + fullHeightCm + "-1-" + cmToPx.toFixed(8),
    image: product.imgLongueur,
    src: product.imgLongueur,
    onLoad: function onLoad() {
      return setLoading(false);
    },
    style: styleImageHaut,
    alt: "Baguette1"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivBas
  }, /*#__PURE__*/_react.default.createElement(Image, {
    key: fullWidthCm + "-" + fullHeightCm + "-2-" + cmToPx.toFixed(8),
    image: product.imgLongueur,
    src: product.imgLongueur,
    onLoad: function onLoad() {
      return setLoading(false);
    },
    style: styleImageBas,
    alt: "Baguette1"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivDroite
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? {} : styleImageDroite
  }, /*#__PURE__*/_react.default.createElement(Image, {
    key: fullWidthCm + "-" + fullHeightCm + "-3-" + cmToPx.toFixed(8),
    image: product.imgLongueur,
    src: product.imgLongueur,
    onLoad: function onLoad() {
      return setLoading(false);
    },
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? styleImageDroite : {},
    alt: "Baguette1"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivGauche
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? {} : styleImageGauche
  }, /*#__PURE__*/_react.default.createElement(Image, {
    key: fullWidthCm + "-" + fullHeightCm + "-4-" + cmToPx.toFixed(8),
    image: product.imgLongueur,
    src: product.imgLongueur,
    onLoad: function onLoad() {
      return setLoading(false);
    },
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? styleImageGauche : {},
    alt: "Baguette1"
  }))), !props.pageProduit.dimensionsDefault && props.showDimensions && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: largeurSujetS,
    id: "dimLargeur"
  }, parseFloat(parseFloat(largeur + (product.fa_id === 475 ? 10 : 0)).toFixed(2)), "cm"), /*#__PURE__*/_react.default.createElement("div", {
    style: hauteurSujetS,
    id: "dimHauteur"
  }, parseFloat(parseFloat(hauteur + (product.fa_id === 475 ? 10 : 0)).toFixed(2)), "cm")), doublo !== null ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivHaut2
  }, /*#__PURE__*/_react.default.createElement(Image, {
    image: doublo.imgLongueur,
    src: doublo.imgLongueur,
    style: styleImageHaut2,
    ref: imgDoublo,
    onLoad: function onLoad() {
      return setLoading2(false);
    },
    alt: "Baguette1",
    key: fullWidthCm + "-" + fullHeightCm + "-2-1-" + cmToPx.toFixed(8)
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivBas2
  }, /*#__PURE__*/_react.default.createElement(Image, {
    image: doublo.imgLongueur,
    src: doublo.imgLongueur,
    key: fullWidthCm + "-" + fullHeightCm + "-2-2-" + cmToPx.toFixed(8),
    style: styleImageBas2,
    onLoad: function onLoad() {
      return setLoading2(false);
    },
    alt: "Baguette1"
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivDroite2
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? {} : styleImageDroite2
  }, /*#__PURE__*/_react.default.createElement(Image, {
    image: doublo.imgLongueur,
    src: doublo.imgLongueur,
    key: fullWidthCm + "-" + fullHeightCm + "-2-3-" + cmToPx.toFixed(8),
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? styleImageDroite2 : {},
    onLoad: function onLoad() {
      return setLoading2(false);
    },
    alt: "Baguette1"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivGauche2
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? {} : styleImageGauche2
  }, /*#__PURE__*/_react.default.createElement(Image, {
    image: doublo.imgLongueur,
    src: doublo.imgLongueur,
    key: fullWidthCm + "-" + fullHeightCm + "-2-4-" + cmToPx.toFixed(8),
    style: typeof process.env.PUBLIC_DIR !== "undefined" ? styleImageGauche2 : {},
    onLoad: function onLoad() {
      return setLoading2(false);
    },
    alt: "Baguette1"
  })))) : null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      top: cadreHauteurPx / 2,
      textAlign: "center",
      position: "absolute"
    }
  }, /*#__PURE__*/_react.default.createElement("strong", null, service === "plexi_normal" ? "+ Plexi normal traité anti UV" : service === "plexi_anti_reflet" ? "+ Plexi anti-reflet traité anti UV" : service === "verre_anti_reflet" ? "+ Verre anti-reflet" : service === "verre_normal" || service === "double_verre_normal" ? "+ Verre normal" : service === "verre_invisible" || service === "double_verre_invisible" ? "+ Verre qualité musée" : "")), /*#__PURE__*/_react.default.createElement("div", {
    style: styleDivPhotos
  }, Object.values(props.photos).map(function (photo) {
    return /*#__PURE__*/_react.default.createElement(_idxImage.IdxImage, {
      key: photo.miniature,
      src: photo.miniature
    }, function (_ref) {
      var image = _ref.image;
      return /*#__PURE__*/_react.default.createElement("div", {
        style: (0, _extends2.default)({}, stylePhotos, {
          backgroundImage: "url(" + image + ")"
        })
      });
    });
  })), props.photo !== null ? /*#__PURE__*/_react.default.createElement("div", {
    style: stylePhoto
  }) : null, ['simple', "multivues"].includes(pp.type) && pp.default ? /*#__PURE__*/_react.default.createElement("div", {
    id: "bordurePasse",
    style: {
      position: "absolute",
      zIndex: 3,
      width: (largeurIntra - pp.margeG - pp.margeD) * cmToPx,
      height: (hauteurIntra - pp.margeB - pp.margeH) * cmToPx,
      left: (largeurBaguettes + pp.margeG) * cmToPx,
      top: (largeurBaguettes + pp.margeH) * cmToPx,
      border: "1px solid red"
    }
  }) : null, ![null, "aucun"].includes(pp.type) && pp.pp !== null && !pp.default ? /*#__PURE__*/_react.default.createElement("div", {
    id: "passe",
    style: {
      position: "absolute",
      zIndex: 3,
      left: largeurBaguettes * cmToPx,
      top: largeurBaguettes * cmToPx
    }
  }, /*#__PURE__*/_react.default.createElement(_previsuPasse.PrevisuPasse, {
    aspectProduit: props.aspectProduit,
    product: props.pageProduit.pp.pp,
    pageProduit: props.pageProduit,
    cmToPx: cmToPx,
    couleurInterieur: bg
  })) : null));
};

exports.PrevisuCadreComplet = PrevisuCadreComplet;
PrevisuCadreComplet.defaultProps = {
  photo: null,
  aspectProduit: null,
  marginEdit: false,
  showDimensions: true
};
PrevisuCadreComplet.propTypes = {
  showDimensions: _propTypes.default.bool,
  product: _propTypes.default.object,
  largeurFixe: _propTypes.default.number,
  hauteurFixe: _propTypes.default.number,
  photo: _propTypes.default.string,
  photos: _propTypes.default.object,
  pageProduit: _propTypes.default.object,
  aspectProduit: _propTypes.default.object,
  marginEdit: _propTypes.default.bool,
  actionsPasse: _propTypes.default.object,
  couleurInterieur: _propTypes.default.string
};
var _default = PrevisuCadreComplet;
exports.default = _default;